import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UiService } from '@s-services/ui.service';
import { Auth, applyActionCode, checkActionCode, confirmPasswordReset, sendPasswordResetEmail, verifyPasswordResetCode } from '@angular/fire/auth';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    imports: [FormsModule]
})
export class AuthComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  auth: Auth = inject(Auth);
  mode!: string;
  code!: string;

  displayPasswordForm = false;
  displayEmailVerifyForm = false;
  displayRecoverEmailForm = false;

  constructor(private route: ActivatedRoute,
    private uiService: UiService,
    private router: Router) {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.mode = params['mode'];
      this.code = params['oobCode'];
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async ngOnInit() {
    // RESET PASSWORD
    try {
      await verifyPasswordResetCode(this.auth, this.code);
      if (this.mode === 'resetPassword') {
        this.displayPasswordForm = true;
      } else if (this.mode === 'verifyEmail') {
        this.onVerifyEmail();
      } else if (this.mode === 'recoverEmail') {
        this.displayRecoverEmailForm = true;
      }
    } catch (e) {
    }
  }

  checkPasswordConsistency(form: NgForm) {
    if (form.controls['pwd1'].value !== form.controls['pwd2'].value) {
      form.controls['pwd2'].setErrors({ 'incorrect': true });
    }
  }

  async onUpdatePassword(form: NgForm) {
    const newPassword = form.value.pwd1;
    this.uiService.loading.next(true);
    try {
      await confirmPasswordReset(this.auth, this.code, newPassword);
      this.uiService.loading.next(false);
      this.uiService.showSimpleSnackbarSuccess('Passwort zurückgesetzt');
      this.router.navigate(['/']);
    } catch (e) {
      this.uiService.loading.next(false);
      this.uiService.showSimpleSnackbarSuccess('Ein Fehler ist aufgetreten');
    }
  }

  async onVerifyEmail() {
    this.uiService.loading.next(true);
    try {
      await applyActionCode(this.auth, this.code);
      this.uiService.loading.next(false);
      this.uiService.showSimpleSnackbarSuccess('E-Mail bestätigt!');
      this.router.navigate(['']);
    } catch (e) {
      this.uiService.loading.next(false);
      this.uiService.showSimpleSnackbarSuccess('Ein Fehler ist aufgetreten');
    }
  }

  async onUpdateEMail(form: NgForm) {
    const newEmail = form.value.email;
    // Localize the UI to the selected language as determined by the lang
    // parameter.
    let restoredEmail: string | null = null;
    // Confirm the action code is valid.
    checkActionCode(this.auth, this.code).then((info) => {
      // Get the restored email address.
      restoredEmail = info['data']['email'] ?? null;

      // Revert to the old email.
      return applyActionCode(this.auth, this.code);
    }).then(() => {
      // Account email reverted to restoredEmail

      // TODO: Display a confirmation message to the user.

      // You might also want to give the user the option to reset their password
      // in case the account was compromised:
      sendPasswordResetEmail(this.auth, restoredEmail!).then(() => {
        // Password reset confirmation sent. Ask user to check their email.
      }).catch((error: unknown) => {
        // Error encountered while sending password reset code.
      });
    }).catch((error: unknown) => {
      // Invalid code.
    });
  }

}
